import { render, staticRenderFns } from "./TelstraUIVueSvg.vue?vue&type=template&id=6c9f8472"
import script from "./TelstraUIVueSvg.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueSvg.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports